<!--
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-11-17 11:03:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/live/components/advertising.vue
-->
<!--长图广告位  -->
<template>
   <!-- 长图广告 -->
    <div :class="filePlayer ? 'file-chat-ad' : 'chat-ad'" v-show="RecommendCourse.imagesH5">
      <img @click="jumpAd" :src="RecommendCourse.imagesH5" alt="" />
    </div>
</template>

<script>
import { gioPlatform,gioJumpType,handleJumpType } from '@/utils/tools';
export default {
  data() {
    return {
      gioVideoId:this.$route.query.roomId
    };
  },
  props:{
    RecommendCourse:{
      type:Object,
    default:()=>{}
    },
    filePlayer:{
      type: Boolean,
      default: false
    }

  },
  components: {},

  computed: {},

  mounted() {

  },

  created() {},
  methods: {
    //广告位内容跳转
    jumpAd() {
      this.gioEvent()
      const {
        skipType,
      } = this.RecommendCourse;
      //特殊处理todo
      if(skipType ===1){
        if (!this.$root.$data.isApp){
          this.$emit('destroyLiveRoom')
        } 
      }
      handleJumpType(this, this.RecommendCourse);
    },
    gioEvent() {
       const {
        skipType,
      } = this.RecommendCourse;
      const adId = this.RecommendCourse.id;
      // 点击广告
      // eslint-disable-next-line
        gio('track', 'adClick_event', {
        adPosition_var: "直播间广告图", // 广告位置
        pageName_var: '直播间', // 页面名称
        videoID_var:this.gioVideoId,
        adSequence_var: null, // 广告序号
        adId_var: adId.toString(), // 广告ID
        adName_var: null, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: gioJumpType(skipType), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.file-chat-ad {
  position: absolute;
  top: 118px;
  z-index: 1;
  width: 100%;
  height: 166px;
  background: #aaa;
  img {
    width: 100%;
    height: 166px;
  }
}
.chat-ad {
  width: 100%;
  height: 166px;
  background: #aaa;
  img {
    width: 100%;
    height: 166px;
  }
}
</style>
